export interface JsonContractProduct {
  numProduit?: number;
  name?: string;
  idGroupeAnnonceur?: number;
}

export class ContractProduct {
  id: number;
  name: string;
  advertiserId: number;

  constructor(jsonContractProduct: JsonContractProduct = null) {
    this.id = jsonContractProduct.numProduit;
    this.name = jsonContractProduct.name;
    this.advertiserId = jsonContractProduct.idGroupeAnnonceur;
  }
}
